import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";

export default function HowOrder() {
  const { t } = useLanguage();
  return (
    <section data-testid="how-order-section" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-5 lg:px-10">
        <Reveal className="mb-4 text-center">
          <h2 className="font-serif-display text-3xl font-medium text-[#111] sm:text-4xl">{t.howOrder.title}</h2>
        </Reveal>
        <Reveal className="mb-12 text-center">
          <p className="mx-auto max-w-xl font-body text-sm text-[#777]">{t.howOrder.cta}</p>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {t.howOrder.steps.map(([title, text], i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div data-testid={`how-step-${i}`} className="h-full rounded-2xl border border-[#eee] bg-[#f7f7f5] p-6">
                <span className="font-serif-display text-3xl text-[#ccc]">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-3 font-body text-base font-medium text-[#111]">{title}</h3>
                <p className="mt-2 font-body text-sm text-[#777]">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-8">
          <p className="mx-auto max-w-2xl rounded-xl bg-[#f7f7f5] px-6 py-4 text-center font-body text-xs leading-relaxed text-[#888]">
            {t.howOrder.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
